import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsagesGroup_Create_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ServiceUsagesGroup_Create(
      $isOptional: Boolean
      $label: String!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      createResolvableMissionTypeServiceUsagesGroup(
        isOptional: $isOptional
        label: $label
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useCreateResolvableMissionTypeServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ServiceUsagesGroup_Create_Mutation,
  );
